"use client";

import { c as _c } from "react/compiler-runtime";
import type { NarmesteLederForm } from "@/schemas/nærmestelederFormSchema";
import { useMockSubmitAction } from "./useMockSubmitAction";
export const useMockOppdaterNarmesteLederAction = () => {
  const $ = _c(4);
  const {
    action,
    isPending,
    error
  } = useMockSubmitAction();
  let t0;
  if ($[0] !== action || $[1] !== error || $[2] !== isPending) {
    t0 = {
      startOppdaterNarmesteLeder: action,
      isPending,
      error
    };
    $[0] = action;
    $[1] = error;
    $[2] = isPending;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0 as const;
};